/*
 * @Author: your name
 * @Date: 2021-07-20 14:18:36
 * @LastEditTime: 2022-08-10 16:31:07
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edi
 * @FilePath: \admine:\LBB\front_end_nest_app_project\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/assets/fonts/font.css'
// import 'lib-flexible/flexible'
import { Dialog, ActionSheet, PasswordInput, NumberKeyboard, Button, Image as VanImage, Lazyload, Icon, Tab, Tabs, Search, DropdownMenu, DropdownItem, Checkbox, CheckboxGroup, Swipe, SwipeItem, Popup, Cell, Form, GoodsAction, GoodsActionIcon, GoodsActionButton, Toast, Rate, Tag, Divider, TreeSelect, List, Field, NavBar } from 'vant'
import Viewer from 'v-viewer'
import 'viewerjs/dist/viewer.css'
import publicFun from '@/utils/index.js'

//全局api和http
import api from "@/api"
import './utils/touch'
import request from "@/utils/server.js"
Vue.prototype.$api = api
Vue.prototype.$http = request
Vue.prototype.$Toast = Toast
Vue.prototype.$Dialog = Dialog
Vue.prototype.$publicFun = publicFun


Viewer.setDefaults({
  Options: { "inline": true, "button": true, "navbar": true, "title": true, "toolbar": true, "tooltip": true, "movable": true, "zoomable": true, "rotatable": true, "scalable": true, "transition": true, "fullscreen": true, "keyboard": true, "url": "data-source" }
});
import '@/assets/css/base.css'
Vue.use(Viewer)
  .use(Button)
  .use(VanImage)
  .use(Lazyload)
  .use(Icon)
  .use(Tab)
  .use(Tabs)
  .use(Search)
  .use(DropdownMenu)
  .use(DropdownItem)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Dialog)
  .use(Swipe)
  .use(SwipeItem)
  .use(Popup)
  .use(Cell)
  .use(Form)
  .use(GoodsAction)
  .use(GoodsActionButton)
  .use(GoodsActionIcon)
  .use(Toast)
  .use(Rate)
  .use(Tag)
  .use(Divider)
  .use(TreeSelect)
  .use(List)
  .use(Field)
  .use(PasswordInput)
  .use(NumberKeyboard)
  .use(ActionSheet)
  .use(NavBar);
Vue.config.productionTip = false;


// v7.9.3.13 渠道码需求加参数
router.afterEach(() => {
  // console.log(router.history.current, '00000')
  let origin = location.origin.indexOf('localhost') == -1 ? location.origin : location.origin + '/#'
  let url = origin + router.history.current.path || ''
  let channel = router.history.current.query.channel || ''
  if (sessionStorage.getItem('url')) {} else {
    sessionStorage.setItem('url', url)
  }
  if (channel) {
    // 如果路径有channel 更新channel
    sessionStorage.setItem('channel', channel)
  } else {
    // 如果路径没channel 则取缓存里的channel 有就有 没有拉倒
  }
})
Vue.prototype.uniJump = (type, data) => {
  uni.getEnv((res) => {
    console.log("当前环境：", res);
  })
  uni.postMessage({
    data: {
      // title: meta[to.name],
      type: type,  // 1关闭   2提货列表   3报价详情
      data: data, // 其他的参数
    },
  });
}

Vue.prototype.wxShare = function (link, title, des, img) {
  this.$http.post(this.$api.weiXinForIm, {
    currentUrl: encodeURIComponent(location.href)
  }).then(res => {
    console.log();
    if (res.code == 200) {
      sessionStorage.setItem('appid', res.ret.appid)
      wx.config({
        debug: false,
        appId: res.ret.appid,
        timestamp: res.ret.timestamp,
        nonceStr: res.ret.nonceStr,
        signature: res.ret.signature,
        jsApiList: [
          "checkJsApi",
          "onMenuShareTimeline",
          "onMenuShareAppMessage",
          "onMenuShareQQ",
          "onMenuShareWeibo",
          "hideMenuItems",
          "showMenuItems",
          "hideAllNonBaseMenuItem",
          "showAllNonBaseMenuItem",
          "startRecord",
          "stopRecord",
          "playVoice",
          "translateVoice",
          "onVoiceRecordEnd",
          "pauseVoice",
          "onVoicePlayEnd",
          "uploadVoice",
          "downloadVoice",
          "updateAppMessageShareData",
          "updateTimelineShareData"
        ],
        openTagList: ['wx-open-launch-app']
      });
      wx.ready(function () {
        wx.onMenuShareAppMessage({ // 分享给朋友以及qq
          title: title, // 分享标题
          desc: des, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function () {
            this.$Toast("成功")
          },
          cancle: function () {
          },
          fail: function (res) {
          }
        });

        wx.onMenuShareTimeline({ // 分享至朋友圈以及QQ空间
          title: title, // 分享标题
          desc: des, // 分享描述
          link: link, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl: img, // 分享图标
          success: function () {
            this.$Toast("成功")
          },
          cancle: function () {
          },
          fail: function (res) {
          }
        });
      });
    } else {
      // window.alert(res.data.msg)
    }
  })
}

document.body.addEventListener('touchstart', function () { });// 解决不能使用伪类元素点击效果
new Vue({
  render: h => h(App),
  router,
  store,
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js